import axios from 'axios';
import cookie from 'js-cookie';
import { bus } from './event';
import { resetCookie } from './nativeEvent';

const requestMap = {};
const xhttp = axios.create();

xhttp.interceptors.request.use(config => {
    if (config.method === 'get') {
        if (requestMap[config.url] && config.cancel) {
            requestMap[config.url].cancel();
        }
        requestMap[config.url] = axios.CancelToken.source();
        config.cancelToken = requestMap[config.url].token;
    }
    resetCookie();
    return config;
});

xhttp.interceptors.response.use(
    response => {
        const { config } = response;
        if (config.method === 'get' && requestMap[config.url]) {
            delete requestMap[config.url];
        }

        const res = response.data;
        if (res.code === 0 || res.result) {
            return res.data;
        }
        bus.$emit(String(res.code));
        return Promise.reject(
            new Error({
                data: res.data,
                message: res.msg,
                code: res.code,
                toString() {
                    return this.message;
                }
            })
        );
    },
    error => {
        if (!error.response) {
            return Promise.reject(
                new Error({
                    message: '网络连接失败',
                    code: -1,
                    toString() {
                        return this.message;
                    }
                })
            );
        }

        if (error.response.status === 400 || error.response.status === 401) {
            const isDev = cookie.get('paas_env') === 'dev';
            if (isDev) {
                cookie.remove('paas_token');
            } else {
                cookie.remove('paas_admin_token');
            }
            location.reload();
        }
        bus.$emit(String(error.response.status));
        return Promise.reject(error);
    }
);

export default xhttp;
